import React, { Component } from 'react'
import classNames from 'classnames'

import '../MessageAttachmentsSection.sass'
import './MessageAttachmentsSectionButton.sass'
import ModalContainer from '@/components/commons/Modal/Modal'
import MessageAttachmentsSectionViewer from '../MessageAttachmentsSectionViewer/MessageAttachmentsSectionViewer'
import Attachment from '@/components/WritingMessageModal/MessageModalContent/AttachmentSection/Attachment'

class MessageAttachmentsSectionButton extends Component {
  constructor (props) {
    super(props)

    this.state = {
      showModal: false
    }
  }

  handleOnClick (attachment, file_ext) {
    const allowedExtensions = ['pdf', 'png', 'jpeg', 'svg', 'jpg', 'gif']
    if (allowedExtensions.indexOf(file_ext.toLowerCase()) === -1) {
      // Download
      const a = document.createElement('a')
      a.href = attachment.uri || attachment.url
      a.click()
    } else {
      this.setState(
        { showModal: true }
      )
    }
  }

  buttonModalOpener (attachment, file_ext, allAttachments) {
    return <div className="-modal-button" onClick={() => { this.handleOnClick(attachment, file_ext) }}>
      <Attachment key={attachment} file_ext={file_ext} attachment={attachment} readOnly={true} allAttachments={allAttachments}/>
    </div>
  }

  render () {
    const { props: { attachment, allAttachments } } = this
    const { filename } = attachment
    const file_ext = filename.split('.').pop()
    return <div className={classNames('-attachment', 'ext-' + file_ext)}>
      {this.buttonModalOpener(attachment, file_ext, allAttachments)}
      { this.state.showModal && <ModalContainer
      showModal={this.state.showModal}
      modalType={'messageAttachmentViewer'}
      modalContent={
        <div>
          <MessageAttachmentsSectionViewer
            allAttachments={allAttachments}
            attachment={attachment}
            file_ext={file_ext}
            closeModal={() => { this.setState({ showModal: false }) }}
          />
          <button className="-close-modal-attachment" onClick={() => { this.setState({ showModal: false }) }}>
            <img src="assets/icons/arrow-left-solid.svg" />
          </button>
        </div>}
      /> }
    </div>
  }
}

export default MessageAttachmentsSectionButton
